module.exports = __webpack_public_path__ + "static/Order-944e9bc17f47c1aaa22eb0218e0b341a.png";